export default "__VITE_ASSET__DgoyZUvu__"